export const removeHtmlTagsFromString = (htmlString: string): string => {
  const htmlElement = document.createElement('span')
  htmlElement.innerHTML = htmlString
  return htmlElement.textContent || htmlElement.innerText
}
